module.exports = __webpack_public_path__ + "img/home-mockup.6874b2d6.png";